/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import Select from 'react-select';
import { getParcelsInPrecint } from '../../lib/utils';
import { createWmtsLayer } from '../../components/utils/wmtsLayer.js'; 
import { isMobileView, isTabletView, layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import MessageModal from './MessageModal';
import { POG_SERVICES } from './constants';
import ModalAlert from './ModalAlert';
import Lightbox from 'react-images';
import waiting from './images/waiting-wheel-300x300.gif';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';

const isBrowser = typeof window !== 'undefined' && window !== null;
let Map, TileLayer, L, WMSTileLayer, Rectangle, GeoJSON, Pan, MyPan, Marker, Popup;

let srsDict;

if (isBrowser) {
  Popup = require('react-leaflet/lib/Popup').default;
  Map = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  Marker = require('react-leaflet/lib/Marker').default;
  L = require('leaflet');

  srsDict = {
    'default': L.CRS.EPSG900913,
    '4326': L.CRS.EPSG4326,
    '2180': L.CRS.EPSG2180,
  };
}
// Styling of waitingCircle
const waitingContainer = {
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '30px',
  marginBottom: '30px',
  display: 'block',
  maxWidth: '600px',
  width: '100%',
  textAlign: 'center',
};

const loadingBody =
  (<div style={{ height: '100px' }}>
    <div style={{ textAlign: 'center' }}>
      <img alt="Loader" src={waiting} style={{ width: '150px', height: '150px' }} />
    </div>
    <p style={{ textAlign: 'center' }}>
        Proszę czekać. Trwa generowanie wydruku.
    </p>
  </div>);

const loadingTitle = <p>Generowanie wydruku...</p>;

const getCenterAsObj = bounds => {
  return { lat: (bounds.maxy + bounds.miny) / 2, lng: (bounds.maxx + bounds.minx) / 2 };
}

const leftCol = 'col-sm-1';
const labelCol = 'col-sm-2';
const inputCol = 'col-sm-6';
const rightCol = 'col-sm-3';
// really simple styles
const labelStyle = { marginTop: '.5rem' };

const studiumServices = [
  'WypisIWyrysZeStudium',
  'WypisZeStudium',
  'WyrysZeStudium',
  'ZmianaSUIKZP',
  'InformacjaSTUDIUM',
  'ZaswiadczenieStudium',
];

const mpzpServices = [
  'WypisZMpzp',
  'WyrysZMpzp',
  'ZaswiadczenieMPZP',
  'WypisIWyrysZMpzp',
  'SporzadzenieMPZP',
  'UwagaMPZP',
  'UwagiMPZP',
  'WniosekMPZP',
  'WniosekUproszczonyWypis',
  'WniosekUproszczonyWyrys',
  'ZgodnoscMPZP',
  'ZgodnoscBudowy',
  'ZmianaMPZP',
  'uproszczony_wypis',
  'wypis_i_wyrys',
  'ZagospDzialkiInfo',
  'ZaswiadczenieOPrzeznaczeniu',
  'DecyzjeWZ',
  'DecyzjeULICP',
  'DecyzjeWZULICP',
  'ZmianaWarunkowZabudowy',
  'ZmianaWZ',
  'PrzeniesienieWZ',
  'WnOpiniaPodzialu',
  'PrzeniesienieDecyzjiOWarunkachZabudowy',
  'WydanieWZ',
  'WydanieDecyzjiULICP',
  'WydanieDecyzjiWZ',
  'WniosekWZ',
  'WniosekULICP',
  'WnZmianaMPZP',
  'WnSporzadzenieMPZP',
  'ZaswiadczenieRewitalizacja',
];


class CustomizedMap extends React.Component {
  constructor(props) {
    super(props);

    this.start_bounds = {
      maxx: this.props.mapState.maxLat,
      maxy: this.props.mapState.maxLon,
      minx: this.props.mapState.minLat,
      miny: this.props.mapState.minLon,
    }
    this.map_center = [this.props.mapState.centerLon, this.props.mapState.centerLat];

    this.state = {
      bounds: this.start_bounds,
      center: this.map_center,
      prefix: this.props.prefix,
      selectedPrecint: '',
      isMounted: false,
      parcelFeatures: [],
      listTrees: [],
      drogiFeatures: {
        type: 'FeatureCollection',
        features: [],
      },
      isMoveMapActive: false,
      isSelectionEnabled: false,
      isTreeSelectionEnabled: false,
      isGraveSelectionEnabled: false,
      selectedParcels: [],
      parcels: null,
      roadFeatures: [],
      selectedRoads: [], // Wybrane drogi
      roads: null, //Wszystkie drogi
      selectedAddress: '',
      adresses: null,
      startPoint: null,
      endPoint: null,
      showMessage: false,
      areParcelsInMPZP: true,
      nonMpzpAlert: false,
      MpzpAlert: false,
      mpzpList: [],
      nonMpzpList: [],
      areParcelsInPOG: true,
      nonPogAlert: false,
      nonPogList: [],
      selectWybor: false, //czy pokazac input z wyborem
      selectDzialki: false, //Czy pokazac wybor z dzialkami
      selectDrogi: false, //Czy pokazac wybor z drogami
      selectedSposob: '0', //Wybrany sposob drogi/dzialki
      errorTitle: null,
      errorText: null,
      showError: false,
      parcelError: null,
      defaultMapComposition: null,
      externalLayers: [],
      wybranyGrob: null,
      showPopup: null,
      mapCenter: [],
      lightboxIsOpen: false,
      lightboxCurrentImg: 0,
      mpzpWMSLayer: null,
      mpzpWMTSLayerAdded: false,
      suikzpWMSLayer: null,
      suikzpWMTSLayerAdded: false,
      parcelsWMSLayer: null,
      parcelsWMTSLayerAdded: null,
      loading: false,
      colors: 'normal',
      sourceStyle: layoutColorStyle,
      style: {},
    };
  }

  hideTime = 2000;

  onHideErrorModal = () => this.setState({ showError: false });

  componentDidMount = () => {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }

    this.setState(
      {
        selectedPrecint: this.props.obreby[0].obreb,
        selectedParcels: this.props.selectedParcels,
        isMounted: true,
        colors,
        sourceStyle,
        style
      }, () => this.getParcelsForPrecint()
    );

    if (this.props.selectedParcels.length > 0) {
      for (const parcel of this.props.selectedParcels) {
        const isInListAlready = _.find(this.state.selectedParcels, v => v.value === parcel.value);

        if (!isInListAlready) {
          this.addParcelToMap(parcel);
        }
      }
    }

    // Wczytuje drogi podczas ladownaia strony
    // Wylaczone drogi dla Skierniewic
    if (this.props.dokumentType.enableRoads && this.state.prefix != 'skierniewice') {
      const url = `${process.env.API_URL}/eservices/${this.state.prefix}/roads`;
      fetch(url, { method: 'GET' })
        .then(r => {
          return r.json();
        })
        .then(resp => {

          //Zapisuje do state i usuwa drogi, ktore nie maja nazwy
          this.setState({
            roads: resp.droga.map(v => {
              return { label: v.nr, value: v.nr, id: v.id }
            }).filter(function (v) {
              if (v.label !== null) return v;
            })
          })
        });

      this.setState({
        selectWybor: true,
        selectedSposob: 2,
        selectDrogi: true
      }, this.fetchWMSLayers);
    } else {
      this.setState({
        selectWybor: false,
        selectedSposob: 1,
        selectDzialki: true,
      }, this.fetchWMSLayers);
    }
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego') {
      this.getDistrictComposition();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const parcelFeature = this.state.parcelFeatures;
    let servicesToCheckMPZP = [
      'WypisIWyrysZMpzp',
      'WypisZMpzp',
      'WyrysZMpzp',
      'WniosekUproszczonyWypis',
      'WniosekUproszczonyWyrys',
      'ZaswiadczenieMPZP',
      'ZaswiadczenieOPrzeznaczeniu',
    ];

    // gmina_biala_piska - wyłącz sprawdzanie i generuj puste zaświadczenie
    if ([2816013].includes(this.props.district.teryt)) {
      servicesToCheckMPZP = servicesToCheckMPZP.filter(
        service => service !== 'ZaswiadczenieMPZP'
      );
    }

    // Wyłącz sprawdzanie dla gminy Działdowo, ponieważ nie ma danych mpzp
    const gminaDzialdowoTeryt = 2803022;

    if ((servicesToCheckMPZP.includes(this.props.dokumentType.shortName) || this.props.checkMPZP || this.props.checkNonMPZP) && prevState.parcelFeatures !== this.state.parcelFeatures && parcelFeature.length > 0 && this.props.district.teryt !== gminaDzialdowoTeryt ) {
      // określa dla jakich dokumentów ma wyświetlać komunikat o braku przynależności do mpzp
      this.checkMPZP(parcelFeature);
    }

    if (POG_SERVICES.includes(this.props.dokumentType.shortName) && prevState.parcelFeatures !== this.state.parcelFeatures) {
      // komunikat o braku pokrycia planem ogólnym (pogCount z endpointów parcel / parcel_in_point / parcel_in_box)
      this.checkPOG(parcelFeature);
    }

    if (
      prevState.isMoveMapActive !== this.state.isMoveMapActive ||
      prevState.isSelectionEnabled !== this.state.isSelectionEnabled ||
      prevState.isGraveSelectionEnabled !== this.state.isGraveSelectionEnabled ||
      prevState.isTreeSelectionEnabled !== this.state.isTreeSelectionEnabled ||
      prevState.selectedSposob !== this.state.selectedSposob
    ) {
      this.refreshMapButtons();
    }
  }

  refreshMapButtons = () => {

    if (!this.mapButtons) return;

    const states = {
      move_map: this.state.isMoveMapActive,
      select_parcel: this.state.isSelectionEnabled,
      select_grave: this.state.isGraveSelectionEnabled,
      select_tree: this.state.isTreeSelectionEnabled,
      select_lightpost: this.state.isTreeSelectionEnabled,
    };

    Object.entries(this.mapButtons).forEach(([id, button]) => {

      const isActive = states[id];

      if (isActive) {

        button.classList.add('active');

      } else {

        button.classList.remove('active');

      }

      if (id === 'select_parcel') {

        let newText = this.state.selectedSposob === 2 ? 'Wskaż drogi na mapie' : 'Wskaż działki na mapie';

        button.querySelector('.mytliptxt').textContent = newText;

      }

    });

  };

  fetchWMSLayers = () => {
    const url = `${process.env.API_URL}/eservices/${this.state.prefix}/WMSLayers?shortName=${this.props.serviceType}`;
    fetch(url, { method: 'GET' })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('WMSLayers fetch failed');
        }
      })
      .then(resp => {
        let mpzpWMSLayer = null;
        let suikzpWMSLayer = null;
        let parcelsWMSLayer = null;
        for (const layer of resp.layers) {
          if (layer.type === 'mpzp') {
            mpzpWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            };
          } else if (layer.type === 'suikzp') {
            suikzpWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            };
          } else if (layer.type === 'parcels') {
            parcelsWMSLayer = {
              url: layer.url,
              layer: layer.layer,
              crs: layer.crs,
            };
          } else {
            if (this.mapka && this.mapka.leafletElement) {
              const lyr = L.tileLayer.wms(layer.url, {
                layers: layer.layer,
                format: 'image/png',
                transparent: true,
                crs: srsDict[layer.crs] || undefined
              });
              lyr.addTo(this.mapka.leafletElement);
            }
          }
        }
        this.setState({ mpzpWMSLayer, suikzpWMSLayer, parcelsWMSLayer });
      })
      .catch(error => {
        console.warn(error);
      })
      .finally(() => {
        this.fetchWMTSLayers();
      });
  };
  
  fetchWMTSLayers = () => {
    if (this.mapka && this.mapka.leafletElement) {
      const url = `${process.env.API_URL}/eservices/${this.state.prefix}/WMTSLayers?shortName=${this.props.serviceType}`;
      fetch(url, { method: 'GET' })
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
          throw response;
        })
        .then(resp => {
          let mpzpWMTSLayerAdded = false;
          let suikzpWMTSLayerAdded = false;
          let parcelsWMTSLayerAdded = false;
          for (const layer of resp.layers) {
            if (layer.type === 'mpzp') {
              if (mpzpServices.includes(this.props.serviceType)) {
                this.addWMTSLayer(layer);
                mpzpWMTSLayerAdded = true;
              }
            } else if (layer.type === 'suikzp') {
              if (studiumServices.includes(this.props.serviceType)) {
                this.addWMTSLayer(layer);
                suikzpWMTSLayerAdded = true;
              }
              
            } else if (layer.type === 'parcels') {
              parcelsWMTSLayerAdded = true;
              this.addWMTSLayer(layer);
            } else {
              this.addWMTSLayer(layer);
            }
          }
          this.setState({ mpzpWMTSLayerAdded, suikzpWMTSLayerAdded, parcelsWMTSLayerAdded });
        })
    }
  }

  addWMTSLayer = (layer) => {
    const options = {
      layer: layer.layer,
      tilematrixSet: layer.tilematrix_set,
      format: layer.format,
      style: layer.style,
      tileSize: layer.tile_size,
    };
    if (layer.zoom_offset != null) {
      options.wmtsZoomOffset = layer.zoom_offset;
    }
    if (layer.max_native_zoom != null) {
      options.maxNativeZoom = layer.max_native_zoom;
    }

    const wmtsLayer = createWmtsLayer(layer.url, options);

    wmtsLayer.addTo(this.mapka.leafletElement);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego') {
      this.setState({
        wybranyGrob: newProps.wybranyGrob,
        showPopup: newProps.showPopup,
        mapCenter: newProps.mapCenter,
      });
    }
  }

  getDistrictComposition = () => {
    const url = `${process.env.API_URL}/district/${this.state.prefix}/`;
    fetch(url, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      let defaultMapComposition = null;
      for (const c of resp.compositions) {
        if (c.typ === 'Mapa') {
          defaultMapComposition = c;
        }
      }
      this.setState({
        defaultMapComposition,
      }, () => this.getDistrictExternalLayers());
    })
    .catch(error => {
      console.info(error);
    });
  }

  getDistrictExternalLayers = () => {
    const url = `${process.env.API_URL}/externallayers/${this.state.prefix}`;
    fetch(url)
    .then(r => r.json())
    .then(resp => {
      const externalLayers = resp.externallayers;
      this.setState({
        externalLayers,
      });
    })
    .catch(error => {
      console.info(error);
    });
  }

  onChangePrecint = (e) => this.setState({ selectedPrecint: e.target.value }, () => this.getParcelsForPrecint());

  setParcelError = err => this.setState({
    parcelError: err,
  }, () => setTimeout(() => {
    this.setState({ parcelError: null })
  }, this.hideTime));

  onMapClick = e => {

    const d = new Date();
    const clickDuration = d.getTime() - this.state.startSelectTime;

    if (this.state.isSelectionEnabled && clickDuration < 200) {
      if (this.state.selectDzialki) {
        const isMobile = this.state.isMounted && isMobileView(window);
        const isTablet = this.state.isMounted && isTabletView(window);

        this.getParcelInPoint(e.latlng)
          .then(response => {
            // IF YOU'RE HOLDING CTRL KEY THEN APPEND PARCEL ELSE
            // JUST SET STATE TO NEW PARCEL
            // response.geometry = JSON.parse(response.geometry);
            if (!response) {
              return
            }
            const parcel = {
              value: response.properties.nr_dzialki,
              label: response.properties.nr_dzialki,
              obreb: response.properties.obreb,
            };
            if (Object.keys(response.properties).indexOf('is_intersected') > -1 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {
              if (!response.properties.is_intersected) {
                // shows error beneath map and hides it after X miliseconds
                this.setParcelError("Wskazana działka nie leży w zasięgu drogi");
                return;
              }
            }
            const isInListAlready = _.find(this.state.selectedParcels, v => v.value === response.properties.nr_dzialki);
            if (isMobile || isTablet) {
              this.setState({
                isMouseEvent: true,
                selectedParcels: isInListAlready 
                  ? this.state.selectedParcels.filter(v => v.value !== response.properties.nr_dzialki) 
                  : this.state.selectedParcels.concat(parcel),
              }, () => {
                if (this.props.index !== undefined && this.props.index !== null) {
                  this.props.setParcels(this.state.selectedParcels, this.props.index)
                } else {
                  this.props.setParcels(this.state.selectedParcels);
                }

                if (isInListAlready) {
                  this.removeParcelFromMap(parcel);
                } else {
                  this.addParcelToMap(parcel);
                }
              });
            }
            else {
              this.setState({
                isMouseEvent: true,
                selectedParcels: e.originalEvent.ctrlKey ? this.state.selectedParcels.concat(!isInListAlready ? parcel : []) : !isInListAlready ? [parcel] : [],
              }, () => {
                if (this.props.index !== undefined && this.props.index !== null) {
                  this.props.setParcels(this.state.selectedParcels, this.props.index)
                } else {
                  this.props.setParcels(this.state.selectedParcels);
                }
                if (e.originalEvent.ctrlKey) {
                  if (!isInListAlready) {
                    this.addParcelToMap(parcel);
                  }
                } else {
                  if (!isInListAlready) {
                    this.setState({ parcelFeatures: [], selectedPrecint: parcel.obreb, selectDzialki: true, selectedRoads: [] }, () => this.addParcelToMap(parcel));
                  } else {
                    this.setState({ parcelFeatures: [] })
                  }
                }
              });
            }
            // this.props.checkParcelsMPZP(response.properties.mpzpCount);
          });
      }
      if (this.state.selectDrogi) {
        this.getRoadInPoint(e.latlng)
          .then(r => {
            const road = { label: r.properties.nr_drogi, value: r.properties.nr_drogi, id: r.properties.id };
            const isInListAlready = _.find(this.state.selectedRoads, v => v.value === road.value);
            if (isInListAlready) {
              this.roadRemove(road);
            } else {
              this.roadAdd(road);
            }
          })
          .catch(err => {
            this.setParcelError("Nie wskazano punktu w pobliżu drogi");
            console.info(err)
          })
      }
    }

    if (this.state.isTreeSelectionEnabled) {
      this.addTree(e);
    }
    if (this.state.isGraveSelectionEnabled) {
      this.props.chooseGrave(e, true);
    }
  }

  addTree = (e) => {
    this.setState({
      listTrees: [...this.state.listTrees, {
        number: this.getTreeNumber(),
        latlng: e.latlng,
      }],
    });
  }

  getTreeNumber = () => {
    let number = 0;
    for (const tree of this.state.listTrees) {
      if (tree.number > number) {
        number = tree.number;
      }
    }
    return (number + 1);
  }

  getParcelInPointURL = (latlng) => {
    let baseURL = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_point?lat=${latlng.lat}&lng=${latlng.lng}`;
    if (this.props.serviceType === 'ZimoweUtrzymanieDrog') {
      return `${baseURL}${'&check_intersection=zimowe_utrzymanie_drog'}`;
    }

    if (this.props.serviceType === 'PrzebiegDrogiInfo') {
      return `${baseURL}${'&check_intersection=zimowe_utrzymanie_drog'}`;
    }

    return `${baseURL}${this.pogCheckParam()}`;
  }

  // for POG services the parcel endpoints also report properties.pogCount (coverage by the plan ogólny)
  pogCheckParam = () => (POG_SERVICES.includes(this.props.serviceType) ? '&check_pog=true' : '');

  getParcelInPoint = latlng => fetch(this.getParcelInPointURL(latlng),
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw r;
    })
    .catch(err => {
      this.setState({
        showMessage: true,
      });
    })

  getRoadInPoint = latlng => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road_in_point?lat=${latlng.lat}&lng=${latlng.lng}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Road not found"
    })

  onMouseDown = (e) => {
    if (this.state.isSelectionEnabled) {
      const d = new Date();
      this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
    }
  };

  getParcelsForPrecint = () => getParcelsInPrecint(this.props.district.teryt, this.state.selectedPrecint)
    .then(resp => this.setState({
      parcels: resp.dzialki.map(v => {
        return { value: v, label: v, obreb: this.state.selectedPrecint };
      }),
    })).then(() => this.setState({ parc: this.state.parcels }));

  clearSelection = () => {
    if (this.props.index !== undefined && this.props.index !== null) {
      this.props.setParcels([], this.props.index)
    } else {
      this.props.setParcels([]);
    }
    this.setState({
      parcelFeatures: [], selectedParcels: [], selectedRoads: [], drogiFeatures: {
        ...this.state.drogiFeatures,
        features: []
      }
    }, () => {
      if (this.drogi) {
        this.drogi.leafletElement.clearLayers();
      }
      if (this.dzialki) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.props.setRoads && this.props.setRoads([]);
    });
    this.zoomToHome();
  }

  logChange = val => {
    let parcel = null;
    let isAdding = null;
    if (this.state.selectedParcels.length > val.length) {
      parcel = _.differenceWith(this.state.selectedParcels, val, _.isEqual)[0];
      isAdding = false;
    }
    if (this.state.selectedParcels.length < val.length) {
      parcel = _.differenceWith(val, this.state.selectedParcels, _.isEqual)[0];
      isAdding = true;
    }
    if (parcel) {
      this.setState({ selectedParcels: val, isMouseEvent: false }, isAdding ? () => this.addParcelToMap(parcel) : () => this.removeParcelFromMap(parcel));
    }
  }

  // Fetches road by its id
  getRoadByID = id => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/road/${id}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json()
      }
      throw "Nie znaleziono drogi";
    })


  roadAdd = road => this.getRoadByID(road.id)
    .then(resp => {
      this.setState({
        selectedRoads: this.state.selectedRoads.concat(road), isMouseEvent: false, drogiFeatures: {
          ...this.state.drogiFeatures,
          features: this.state.drogiFeatures.features.concat(resp),
        }
      }, this.refreshRoads);
    });

  roadRemove = road => {
    this.setState({
      selectedRoads: _.filter(this.state.selectedRoads, v => v.id !== road.id),
      drogiFeatures: {
        ...this.state.drogiFeatures,
        features: _.filter(this.state.drogiFeatures.features, v => v.properties.id !== road.id)
      }
    }, this.refreshRoads);
  }

  // Zmienia wartosc w inpucie odnosnie drog
  roadChange = (val) => {
    let road = null;
    let isAdding = null;
    if (this.state.selectedRoads.length > val.length) {
      road = _.differenceWith(this.state.selectedRoads, val, _.isEqual)[0];
      isAdding = false;
    }

    if (this.state.selectedRoads.length < val.length) {
      road = _.differenceWith(val, this.state.selectedRoads, _.isEqual)[0];
      isAdding = true;
    }

    // Przypisuje wartosc do state
    if (road && isAdding) {
      this.roadAdd(road, val);
    }

    if (road && !isAdding) {
      this.roadRemove(road);
    }
  }

  sposobChange = (e) => {
    if (e.target.value == 0) {
      this.setState({
        selectedSposob: 0, selectDrogi: false, selectDzialki: false, selectWybor: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      })
    } else if (e.target.value == 1) {
      this.setState({
        selectedSposob: 1, selectDrogi: false, selectDzialki: true, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: [],
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
        this.props.setSelectDzialki(this.state.selectDzialki);
        this.props.setSelectDrogi(this.state.selectDrogi);
      });
    } else if (e.target.value == 2) {
      this.setState({
        selectedSposob: 2, selectDrogi: true, selectDzialki: false, selectedRoads: [], selectedParcels: [], drogiFeatures: {
          ...this.state.drogiFeatures,
          features: []
        }
      }, () => {
        this.refreshRoads();
        this.refreshParcels();
        this.props.setSelectDrogi(this.state.selectDrogi);
        this.props.setSelectDzialki(this.state.selectDzialki);
      });
    }
  }

  onMouseUp = (e) => {
    if (this.state.isSelectionEnabled) {
      this.setState({ ctrState: e.originalEvent.ctrlKey }, () => this.endSelection());
    }
  };
  onMouseMove = (e) => {
    if (this.state.isSelectionEnabled) {
      // if we have start point then we're drawing
      if (this.state.startPoint) {
        this.setState({ endPoint: e.latlng }, () => {
          if (this.state.ctrState !== e.originalEvent.ctrlKey) {
            this.endSelection();
          }
        });
      }
    }
  };

  removeParcelFromMap = parcel => {
    this.setState({
      parcelFeatures: _.filter(this.state.parcelFeatures, v => {
        if (parcel.label === v.properties.nr_dzialki && parcel.obreb === v.properties.obreb) {
          return;
        }
        return v;
      }),
    }, this.refreshParcels);
  }

  addParcelToMap = parcel => fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel?nr_dzialki=${parcel.label}&precint=${parcel.obreb}${this.pogCheckParam()}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw r;
    })
    .then(response => {
      this.setState({ parcelFeatures: this.state.parcelFeatures.concat(response) }, this.refreshParcels);
    });

  getRoadsByBbox = (startP, endP) =>
    fetch(`${process.env.API_URL}/eservices/${this.props.district.teryt}/roads_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`,
      { method: 'GET' })
      .then(r => {
        if (r.status === 200) {
          return r.json()
        }
        throw "Nie zaznaczono działek";
      })

  endSelection = () => {
    // cleanup selection
    // ctrState: false,
    const d = new Date();
    const startP = this.state.startPoint;
    const endP = this.state.endPoint;
    this.setState({ startPoint: null, endPoint: null }, () => {
      const d = new Date();
      const selectTime = d.getTime() - this.state.startSelectTime;
      if (this.state.selectDzialki && selectTime > 200 && endP) {
        // ZimoweUtrzymanieDrog
        let url = `${process.env.API_URL}/eservices/${this.props.district.teryt}/parcel_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`;
        if (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo') {
          url += '&check_intersection=' + 'zimowe_utrzymanie_drog';
        }
        url += this.pogCheckParam();
        fetch(url,
          { method: 'GET' })
          .then(r => {
            if (r.status === 200) {
              return r.json()
            }
            throw r;
          })
          .then(response => {
            let parcels = [];
            let not_valid_parcels = [];
            let filtered_parcels = [];
            for (let i = 0; i <= response.features.length - 1; i++) {

              const parcel = {
                value: response.features[i].properties.nr_dzialki,
                label: response.features[i].properties.nr_dzialki,
                obreb: response.features[i].properties.obreb,
              }
              if (Object.keys(response.features[i].properties).indexOf('is_intersected') > -1 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {
                if (response.features[i].properties.is_intersected) {
                  parcels.push(parcel);
                  filtered_parcels.push(response.features[i]);
                } else {
                  not_valid_parcels.push(parcel);
                }
              } else {
                parcels.push(parcel);
              }

            }
            if (not_valid_parcels.length > 0 && (this.props.serviceType === 'ZimoweUtrzymanieDrog' || this.props.serviceType === 'PrzebiegDrogiInfo')) {

              const errorTitle = 'Błędnie wskazano działki';
              const errorText = "Działki: " + not_valid_parcels.reduce((prev, cur) => cur.value + ';' + prev, '') + " nie znajdują się pobliżu dróg. Działki te nie zostaną dodane do mapy.";
              const showError = true;
              this.setState({
                selectedParcels: parcels,
                parcelFeatures: filtered_parcels,
                errorTitle: errorTitle,
                errorText: errorText,
                showError: showError,
              }, () => this.refreshParcels());
            } else {
              this.setState({ selectedParcels: parcels, parcelFeatures: response.features }, () => this.refreshParcels());
            }
          });
      }
      if (this.state.selectDrogi && selectTime > 200 && endP) {
        this.getRoadsByBbox(startP, endP)
          .then(r => {
            let roads = [];
            for (let i = 0; i <= r.features.length - 1; i++) {
              roads.push({ value: r.features[i].properties.nr_drogi, label: r.features[i].properties.nr_drogi, id: r.features[i].properties.id })
            }
            this.setState({
              selectedRoads: roads, drogiFeatures: {
                ...r
              }
            }, () => this.refreshRoads())
          })
      }
    });
  }
  refreshParcels = () => {
    if (this.props.index !== undefined && this.props.index !== null) {
      this.props.setParcels(this.state.selectedParcels, this.props.index)
    } else {
      this.props.setParcels(this.state.selectedParcels);
    }

    // Refresh roads onle when they are enabled
    if (this.props.dokumentType.enableRoads)
      this.props.setRoads(this.state.selectedRoads);

    if (this.state.selectedParcels.length > 0) {
      if (this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
        const data = {
          type: 'FeatureCollection',
          features: this.state.parcelFeatures,
        };
        const bounds = this.dzialki.leafletElement.addData(data).getBounds();
        // fit map only if it is not a mouse event
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      if (this.dzialki && this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  };

  refreshRoads = () => {
    if (this.state.drogiFeatures.features.length > 0) {
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
        this.props.setRoads(this.state.selectedRoads);
        const bounds = this.drogi.leafletElement.addData(this.state.drogiFeatures).getBounds();
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      this.props.setRoads([]);
      if (this.drogi.leafletElement) {
        this.drogi.leafletElement.clearLayers();
      }
      this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds), 11)
    }
  }
  /* eslint-disable no-underscore-dangle */
  onPan = (e) => {
    const button = e.target.id;

    if (!this.mapka) return;

    const modes = {
      move_map: {
        isMoveMapActive: true,
        isSelectionEnabled: false,
        isTreeSelectionEnabled: false,
        isGraveSelectionEnabled: false
      },
      select_parcel: {
        isMoveMapActive: false,
        isSelectionEnabled: true,
        isTreeSelectionEnabled: false,
        isGraveSelectionEnabled: false
      },
      select_grave: {
        isMoveMapActive: false,
        isSelectionEnabled: false,
        isTreeSelectionEnabled: false,
        isGraveSelectionEnabled: true
      },
      default: {
        isMoveMapActive: false,
        isSelectionEnabled: false,
        isTreeSelectionEnabled: true,
        isGraveSelectionEnabled: false
      }
    };

    const newState = modes[button] || modes.default;

    this.setState(newState, this.changeSelection);
  };

  changeSelection = () => {
    if (this.state.isSelectionEnabled || this.state.isTreeSelectionEnabled || this.state.isGraveSelectionEnabled) {
      this.mapka.leafletElement._container.style.cursor = 'crosshair';
      this.mapka.leafletElement.dragging.disable();
    } else {
      this.mapka.leafletElement._container.style.cursor = '';
      this.mapka.leafletElement.dragging.enable();
    }
  }

  changeCenter = () => {
    let center = this.state.center;
    if (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.state.mapCenter !== null) {
      center = this.state.mapCenter;
    }

    return center;
  }

  changeZoom = () => {
    return (this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.props.zoom !== null) ? this.props.zoom : 12;
  }

  zoomToHome = (e) => {
    this.mapka.leafletElement.zoom=this.changeZoom();
    this.mapka.leafletElement.fitBounds([
      [this.start_bounds.miny, this.start_bounds.minx],
      [this.start_bounds.maxy, this.start_bounds.maxx],
    ]);
  }

  onMapReady = (e) => {
    const map = e.target;   // to jest instancja L.Map

    const buttons = [
      { id: 'move_map',
        title: 'Przesuń mapę',
        className: 'map-control-btn pan_btn mytlip',
        onClick: this.onPan,
      },
    ]

    if (this.props.serviceType == 'OplataZaDzierzaweMiejscaGrzebalnego') {

      buttons.push(
        {
          id: 'select_grave',
          title: 'Wskaż grób na mapie',
          className: 'map-control-btn select_btn mytlip',
          onClick: this.onPan,
        }
      );

    } else {

      buttons.push(
        {
          id: 'select_parcel',
          title: this.state.selectedSposob === 2 ? 'Wskaż drogi na mapie' : 'Wskaż działki na mapie',
          className: 'map-control-btn select_btn mytlip',
          onClick: this.onPan,
        },
      );

    }

    if (this.props.treeSelection) {

      buttons.push(
        {
          id: 'select_tree',
          title: 'Zaznacz drzewo/krzew',
          className: 'map-control-btn select_tree_btn mytlip',
          onClick: this.onPan,
        },
      );

      buttons.push(
        {
          id: 'delete_tree',
          title: 'Usuń drzewa/krzewy',
          className: 'map-control-btn delete_tree_btn mytlip',
          onClick: this.removeAllTrees,
        },
      );

    }

    if (this.props.lightPostSelection) {

      buttons.push(
        {
          id: 'select_lightpost',
          title: 'Zaznacz miejsce awarii',
          className: 'map-control-btn select_lightpost_btn mytlip',
          onClick: this.onPan,
        },
      );

      buttons.push(
        {
          id: 'delete_lightpost',
          title: 'Usuń miejsca awarii',
          className: 'map-control-btn delete_tree_btn mytlip',
          onClick: this.removeAllTrees,
        },
      ); 
    }

    if (this.props.pointSelection) {

      buttons.push(
        {
          id: 'select_lightpost',
          title: 'Zaznacz punkt na mapie',
          className: 'map-control-btn select_lightpost_btn mytlip',
          onClick: this.onPan,
        },
      );

      buttons.push(
        {
          id: 'delete_lightpost',
          title: 'Usuń punkty',
          className: 'map-control-btn delete_tree_btn mytlip',
          onClick: this.removeAllTrees,
        },
      ); 

    }

    buttons.push(
      {
        id: 'zoomTohome',
        title: 'Przywróć pierwotny widok mapy',
        className: 'map-control-btn zoom_to_home_btn mytlip',
        onClick: this.zoomToHome,
      },
    );

    this.mapButtons = {};
    
    const CustomMapControl = L.Control.extend({
      options: {
        position: 'topleft'
      },

      onAdd: () => {

        const container = L.DomUtil.create('div', 'leaflet-bar custom-map-control');
        container.id = 'custom-map-control-panel';

        for (const btn of buttons) {

          const button = L.DomUtil.create(
            'button',
            btn.className,
            container
          );

          button.id = btn.id;
          button.type = 'button';
          button.innerHTML = `<span class="mytliptxt">${btn.title}</span>`;

          L.DomEvent.disableClickPropagation(container);

          L.DomEvent.on(button, 'click', (ev) => {
            L.DomEvent.stop(ev);
            btn.onClick(ev);
          });

          // zapamiętujemy referencję
          this.mapButtons[btn.id] = button;
        }

        return container;
      }
    });

    map.addControl(new CustomMapControl());
  };

  mapRender = () => {
    const deviceWidth = window.innerWidth;
    const mapHeight = deviceWidth >= 560 ? 600 : 450;

    let defaultGap = -34;

    if (this.props.treeSelection || this.props.lightPostSelection) {
      defaultGap = 30;
    }

    const mapStyle = {
      width: '100%',
      height: `${mapHeight}px`,
      border: 'solid 2px black',
      zIndex: 0,
    };

    const mapa = (
      <Map
        ref={m => {
          this.mapka = m;
          window.__MAP__ = m;
        }}
        center={this.changeCenter()}
        style={mapStyle}
        zoom={this.changeZoom()}
        whenReady={(e) => this.onMapReady(e)}
        onClick={(e) => this.onMapClick(e)}
        onMousedown={(e) => this.onMouseDown(e)}
        onMouseup={(e) => this.onMouseUp(e)}
        onMousemove={(e) => this.onMouseMove(e)}
        animate
        tap={false}
        id={this.props.index !== undefined && this.props.index !== null ? `MapToPrint_PDF_${this.props.index}` : "MapToPrint_PDF"}
        bounds={[
          [this.start_bounds.miny, this.start_bounds.minx],
          [this.start_bounds.maxy, this.start_bounds.maxx],
        ]}
        wheelPxPerZoomLevel={120}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          crossOrigin="anonymous"
        />
        <WMSTileLayer
          url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
          format={'image/png'}
          transparent
          layers={'granica_gminy'}
        />

        {this.props.serviceType === 'OplataZaDzierzaweMiejscaGrzebalnego' && this.state.defaultMapComposition !== null ? (
          this.state.defaultMapComposition.layers.sort((a, b) => parseInt(b.nr) - parseInt(a.nr)).map((v, i) => {
            const l = _.find(this.state.externalLayers, o => o.nazwa === v.warstwa);
            return (
              (typeof l === 'undefined') ? (
                <WMSTileLayer
                  key={i}
                  url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
                  format={'image/png'}
                  transparent
                  maxZoom={25}
                  layers={`${this.state.prefix}:${v.warstwa}`}
                />) : (
                  <WMSTileLayer
                    key={i}
                    url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
                    format={'image/png'}
                    transparent
                    layers={l.warstwa}
                    maxZoom={25}
                    version={l.wersja}
                    service={l.typ}
                  />
                )
            );
          })
        ) : null}

        {studiumServices.includes(this.props.serviceType) && (
          this.state.suikzpWMSLayer && !this.state.suikzpWMTSLayerAdded ? (
            <WMSTileLayer
              url={this.state.suikzpWMSLayer.url}
              format="image/png"
              transparent
              layers={this.state.suikzpWMSLayer.layer}
              crs={srsDict[this.state.suikzpWMSLayer.crs]}
            />
          ) : (!this.state.suikzpWMSLayer && !this.state.suikzpWMTSLayerAdded) ? (
            <WMSTileLayer
              url={`https://e-spdp.pl/oldihub/ows/${this.state.prefix}?`}
              format="image/png"
              transparent
              layers={!this.state.parcelsWMSLayer && !this.state.parcelsWMTSLayerAdded ? 'SUiKZP,dzialki' : 'SUiKZP'}
            />
          ) : null
        )}
        {mpzpServices.includes(this.props.serviceType) && (
          this.state.mpzpWMSLayer && !this.state.mpzpWMTSLayerAdded ? (
            <WMSTileLayer
              url={this.state.mpzpWMSLayer.url}
              format="image/png"
              transparent
              layers={this.state.mpzpWMSLayer.layer}
              crs={srsDict[this.state.mpzpWMSLayer.crs]}
            />
          ) : (!this.state.mpzpWMSLayer && !this.state.mpzpWMTSLayerAdded) ? (
            <TileLayer
              ref={m => { this.tilelayer = m; }}
              url={`https://e-spdp.pl/oldihub/wmts/${this.state.prefix}/webmercator/{z}/{x}/{y}.png`}
              layer={`${this.state.prefix}`}
              format="image/png"
              crs={srsDict['default']}
              tileSize={1024}
            />
          ) : null
        )}
        {this.state.parcelsWMSLayer && !this.state.parcelsWMTSLayerAdded ?
          <WMSTileLayer
            url={this.state.parcelsWMSLayer.url}
            format="image/png"
            transparent
            layers={this.state.parcelsWMSLayer.layer}
            crs={srsDict[this.state.parcelsWMSLayer.crs]}
          />
          : null
        }
        {(this.props.serviceType === 'PrzebiegDrogiInfo' || this.props.serviceType === 'ZimoweUtrzymanieDrog') ?
          <WMSTileLayer
            url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
            format={'image/png'}
            transparent
            layers={`${this.state.prefix}:zimowe_utrzymanie_drog`}
          /> : null
        }
        {this.state.parcelFeatures.length > 0 ? (
          <GeoJSON
            ref={m => { this.dzialki = m; }}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.state.parcelFeatures,
            }}
          />
        ) : null}

        <GeoJSON
          ref={obj => { this.drogi = obj; }}
          cursor={'crosshair'}
          data={this.state.drogiFeatures}
        />

        {/*selection rectangle*/}
        {(this.state.startPoint && this.state.endPoint) ? (
          <Rectangle
            bounds={[[this.state.startPoint.lat, this.state.startPoint.lng], [this.state.endPoint.lat, this.state.endPoint.lng]]}
          />
        ) : null}
        {this.state.listTrees.map((val, i) => {
          return (
            <Marker
              key={i}
              position={val.latlng}
              onClick={() => this.removeTree(i)}
              icon={L.divIcon({
                className: 'tree-marker',
                html: `<svg width="20" height="20">
                        <circle cx="10" cy="10" r="9" fill="red" stroke="black" stroke-width="2" />
                        <text x="10" y="15" font-size="12" text-anchor="middle" fill="black">${val.number}</text>
                      </svg>`,
                iconAnchor: [10, 10],
                iconSize: [20, 20],
              })}
            />
          );
        })}
        {this.state.wybranyGrob && this.state.showPopup ?
          <Popup
            autoPan={false}
            position={[this.state.mapCenter[0], this.state.mapCenter[1]]}
            onClose={() => this.setState({ showPopup: false })}
          >
            <div>
              <div style={{ fontSize: '12px' }}>
                <b>
                  <span className={{ fontSize: '14px' }}>
                    {this.state.wybranyGrob.data.imieINazwisko ? this.state.wybranyGrob.data.imieINazwisko : '-'}
                  </span>
                </b>
                <br />
                Data urodzenia: {this.state.wybranyGrob.data.dataUrodz ? this.state.wybranyGrob.data.dataUrodz : '-'}<br />
                Data zgonu: {this.state.wybranyGrob.data.dataZgonu ? this.state.wybranyGrob.data.dataZgonu : '-'}<br />
                Sektor: {this.state.wybranyGrob.data.numerSektora ? this.state.wybranyGrob.data.numerSektora : '-'}<br />
                Rząd: {this.state.wybranyGrob.data.numerRzedu ? this.state.wybranyGrob.data.numerRzedu : '-'}<br />
                Numer grobu: {this.state.wybranyGrob.data.numerGrobu ? this.state.wybranyGrob.data.numerGrobu : '-'}
              </div>
              {this.state.wybranyGrob.images.imagesExists ?
                <div>
                  {this.state.wybranyGrob.images.thumb
                  ?
                    <div
                      className="graveThumb"
                      onClick={() => this.setState({ lightboxIsOpen: true })}
                      style={{ backgroundImage: `url('data:image/jpeg;base64,${this.state.wybranyGrob.images.thumb}')` }}
                      title="Kliknij aby obejrzeć zdjęcia grobu."
                    />
                  :
                    <button
                      className="btn btn-block perfectCenter marginesy cmentarze-background"
                      onClick={() => this.setState({ lightboxIsOpen: true })}
                      title="Kliknij aby obejrzeć zdjęcia grobu."
                    >
                      <span
                        key='images_span'
                        style={{ height: '100%', marginRight: '10px' }}
                      >
                        Zdjęcia
                      </span>
                      <span
                        className="fa fa-file-image-o fa-2x"
                        aria-hidden="true"
                      />
                    </button>
                  }
                  <Lightbox
                    currentImage={this.state.lightboxCurrentImg}
                    images={this.state.wybranyGrob.images.images}
                    isOpen={this.state.lightboxIsOpen}
                    onClose={() => this.setState({ lightboxIsOpen: false, lightboxCurrentImg: 0 })}
                    onClickNext={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg + 1 })}
                    onClickPrev={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg - 1 })}
                  />
                </div> : null}
            </div>
          </Popup>
        : null }
      </Map>
    );

    this.mapa = mapa;

    return (
      <div
        className="map-container"
        style={{
          position: 'relative',
          margin: '20px 0',
        }}
      >
        {mapa}
      </div>
    );
  }
  removeAllTrees = () => {
    this.setState({
      listTrees: [],
    });
  }

  removeTree = (i) => {
    const list = [...this.state.listTrees];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      listTrees: list,
    });
  }
  onChangeAddress = val => {
    this.getParcelInPoint({ lat: val.lat, lng: val.lon })
      .then(resp => {
        const parcel = {
          value: resp.properties.nr_dzialki,
          label: resp.properties.nr_dzialki,
          obreb: resp.properties.obreb,
        };
        this.setState({
          selectedParcels: this.state.selectedParcels.concat(parcel),
          selectedAddress: { value: resp.properties.nr_dzialki, label: val.display_name, obreb: resp.properties.obreb },
          parcelFeatures: this.state.parcelFeatures.concat(resp)
        }, this.refreshParcels);
      })
      .catch(err => {
        // TODO: Create message box with information that user choosen address point outside district
      });
  }
  inputAdressChange = e => {
    const query = `http://nominatim.openstreetmap.org/search/pl?format=json&q=${e}&accept-language=pl-PL&countrycodes=pl`;
    fetch(query, { method: 'GET' })
      .then(r => {
        return r.json();
      })
      .then(resp => {
        this.setState({
          adresses: resp.map(address => {
            return { ...address, label: <span><img src={address.icon} alt="Address Icon" />{address.display_name}</span>, value: address.display_name };
          })
        })
      }
      );
  }

  matcher = e => {
    let matches = [];
    let matchesLength = [];
    let substrRegex = new RegExp("^" + e, 'i');
    let mach = {}
    this.state.parc.forEach(parc => {
      let s = parc.value.split('-');
      if (s[1] && substrRegex.test(s[1])) {
        let dictKey = `lenght${Math.abs(e.length - s[1].length)}`;
        if (Object.keys(mach).indexOf(dictKey) >= 0) {
          mach[dictKey].push(parc);
        } else {
          mach[dictKey] = [parc];
        }
        if (s[1].length === e.length) {
          matchesLength.push(parc)
        } else {
          matches.push(parc)
        }

      }
    });
    let machKeys = Object.keys(mach).sort();
    let odpSum = [];
    for (let key of machKeys) {
      odpSum = [...odpSum, ...mach[key]];
    }
    this.setState({ parcels: odpSum });
  }

  // pogCount: 0 = outside the plan ogólny, null/undefined = no POG data for the district (do not block)
  isParcelInPog = feature => {
    const count = feature && feature.properties ? feature.properties.pogCount : undefined;
    const isPogDataAvailable = count !== undefined && count !== null;
    return !(isPogDataAvailable && count <= 0);
  }

  checkPOG = (list) => {
    // sprawdza przynależność do planu ogólnego (jak checkMPZP)
    const nonPog = list.filter(i => !this.isParcelInPog(i)).map(i => i.properties.nr_dzialki);
    this.setState({ areParcelsInPOG: !nonPog.length, nonPogAlert: !!nonPog.length, nonPogList: nonPog });
  }

  checkMPZP = (list) => {
    // sprawdza przynależność do mpzp
    const nonMpzp = [];
    const mpzp = [];
    let MpzpParcels = false;
    list.map((i, y) => {
      if (i.properties.mpzpCount <= 0 && i.properties.mpzpCount !== null) {
        nonMpzp.push(i.properties.nr_dzialki);
      } else {
        mpzp.push(i.properties.nr_dzialki);
        MpzpParcels = true;
      }
    });

    this.setState({ areParcelsInMPZP: mpzp.length && !nonMpzp.length, nonMpzpAlert: (!!nonMpzp.length), mpzpList: mpzp, nonMpzpList: nonMpzp, MpzpAlert: MpzpParcels });
  }

  exportMapToPdf = () => {
    const mapComp = this.mapka;
    const map = mapComp && mapComp.leafletElement;
    const el = map.getContainer();
    if (!map || !el) return;

    const A4_WIDTH_PX = 1079;
    const A4_HEIGHT_PX = 754;

    // Zapamiętaj oryginalne style i pozycję mapy
    const { width: prevWidth, height: prevHeight } = el.style;
    const currentCenter = map.getCenter();
    const currentZoom = map.getZoom();

    // Ustaw rozmiar kontenera na A4 landscape
    el.style.width = `${A4_WIDTH_PX}px`;
    el.style.height = `${A4_HEIGHT_PX}px`;

    // Po chwili odśwież mapę i zacznij czekać na kafelki
    setTimeout(() => {
      map.invalidateSize();
      map.setView(currentCenter, currentZoom, { animate: false });
      this.waitForTilesAndExport(
        1,
        60,
        map,
        el,
        prevWidth,
        prevHeight,
        currentCenter,
        currentZoom
      );
    }, 100);
  };

  // Sprawdza, czy wszystkie kafelki załadowane lub zakończone błędem
  areAllTileLayersLoaded = (map) => {
    let allLoaded = true;

    map.eachLayer((layer) => {
      if (layer instanceof L.TileLayer || layer instanceof L.GridLayer) {
        const tileContainer = layer._tiles;
        if (!tileContainer) return;

        for (const key in tileContainer) {
          const tile = tileContainer[key];
          if (!tile.loaded && !tile.error) {
            allLoaded = false;
            break;
          }
        }
      }
    });

    return allLoaded;
  };

  // Czeka na załadowanie kafelków i wywołuje eksport lub błąd po czasie
  waitForTilesAndExport = (
    attempt,
    maxAttempts,
    map,
    el,
    prevWidth,
    prevHeight,
    currentCenter,
    currentZoom
  ) => {
    if (this.areAllTileLayersLoaded(map)) {
      this.performExport(el, prevWidth, prevHeight, map, currentCenter, currentZoom);
    } else if (attempt >= maxAttempts) {
      el.style.width = prevWidth;
      el.style.height = prevHeight;
      this.setState({
        errorTitle: 'Błąd generowania wydruku',
        errorText: 'Przekroczono czas oczekiwania na wygenerowanie wydruku. Spróbuj ponownie',
        showError: true,
        loading: false,
      });
    } else {
      setTimeout(() => {
        this.waitForTilesAndExport(
          attempt + 1,
          maxAttempts,
          map,
          el,
          prevWidth,
          prevHeight,
          currentCenter,
          currentZoom
        );
      }, 500);
    }
  };

  // Wykonuje drukowanie i przywraca style po zakończeniu
  performExport = (el, prevWidth, prevHeight, map, currentCenter, currentZoom) => {
    const cleanup = () => {
      el.classList.remove('print-target');
      el.style.width = prevWidth;
      el.style.height = prevHeight;
      map.setView(currentCenter, currentZoom);
      window.removeEventListener('afterprint', cleanup);
      this.setState({ loading: false });
    };

    const startPrinting = () => {
      el.classList.add('print-target');
      window.addEventListener('afterprint', cleanup);
      window.print();
    };

    this.setState({ loading: false }, startPrinting);
  };


  render() {
    const validMpzp = this.props.checkNonMPZP ? this.state.mpzpList.length > 0 : this.state.areParcelsInMPZP;
    const validPog = POG_SERVICES.includes(this.props.serviceType) ? this.state.areParcelsInPOG : true;
    if (this.props.mpzpValidator) this.props.mpzpValidator(validMpzp && validPog);
    let obreby = this.props.obreby;
    if (obreby && typeof (obreby) === 'string') {
      obreby = JSON.parse(this.props.obreby);
    }

    const ZaswiadczenieOPrzeznaczeniuCheck = this.props.dokumentType.shortName === 'ZaswiadczenieOPrzeznaczeniu' && this.state.selectedParcels.length > 0;

    return (
      <div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHideErrorModal}
        />
        <ModalAlert
          title={loadingTitle}
          bodyText={loadingBody}
          show={this.state.loading}
          name="mapPrintLoadingModal"
          onHide={this.onHide}
          disableButton
          style={{ zIndex: 9999 }}
        />
        {this.state.loading && <div className="print-overlay" style={this.state.style}/>}
        {!this.state.areParcelsInMPZP && !ZaswiadczenieOPrzeznaczeniuCheck && !this.props.checkNonMPZP ? <MessageModal message={2} messageText={this.state.nonMpzpList} openModal={this.state.nonMpzpAlert} closeModal={() => this.setState({ nonMpzpAlert: false })} /> : null}
        {this.state.mpzpList && this.props.checkNonMPZP ? <MessageModal message={ZaswiadczenieOPrzeznaczeniuCheck? 3 : 4} messageText={this.state.mpzpList} openModal={this.state.MpzpAlert} closeModal={() => this.setState({ MpzpAlert: false })} teryt={this.props.district.teryt} /> : null}
        {this.state.showMessage ? <MessageModal message={1} openModal={this.state.showMessage} closeModal={() => this.setState({ showMessage: false })} /> : null}
        {POG_SERVICES.includes(this.props.serviceType) ? <MessageModal message={5} messageText={this.state.nonPogList} openModal={this.state.nonPogAlert} closeModal={() => this.setState({ nonPogAlert: false })} /> : null}
        {this.props.dokumentType.enableAddress &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="select-address" style={labelStyle} >Adres</label>
            </div>
            <div className={inputCol}>
              <Select
                id="select-address"
                noResultsText={'brak wyników'}
                placeholder={<span style={{ color: '#555' }}>Wpisz adres...</span>}
                name="form-field-name"
                value={this.state.selectedAddress}
                options={this.state.adresses}
                clearable
                rows={5}
                onInputChange={this.inputAdressChange}
                onChange={this.onChangeAddress}
                onBlur={event => event.preventDefault()}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />
            </div>
            <div className={rightCol}>
              <button
                onClick={() => {
                  this.setState({ selectedAddress: '', selectedParcels: [], parcelFeatures: [] }, () => {
                    if (this.props.index !== undefined && this.props.index !== null) {
                      this.props.setParcels(this.state.selectedParcels, this.props.index)
                    } else {
                      this.props.setParcels(this.state.selectedParcels);
                    }
                    this.props.setRoads(this.state.selectedRoads);

                    this.mapka.leafletElement.setView(getCenterAsObj(this.state.bounds),
                      11);
                  }
                  )
                }}
                className="btn btn-default" type="submit"><strong>Wyczyść</strong>
              </button>
            </div>
          </div>
        }

        {this.props.dokumentType.enableRoads && this.state.selectWybor &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="szukaj" style={labelStyle} >Wyszukaj na podstawie</label>
            </div>

            <div className={inputCol}>
              <select
                name="find"
                className="form-control needsclick"
                value={this.state.selectedSposob}
                onChange={(e) => this.sposobChange(e)}
              >
                <option value="0">Wybierz sposób...</option>
                <option value="1">Działki</option>
                <option value="2">Drogi</option>

              </select>
            </div>
            <div className={rightCol} />
          </div>
        }

        {this.props.dokumentType.enablePrecints && this.state.selectDzialki && this.state.selectedSposob !== 2
        && this.props.serviceType !== 'OplataZaDzierzaweMiejscaGrzebalnego' &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="select-precint" style={labelStyle} >Obręby</label>
            </div>
            <div className={inputCol}>
              <select
                id="select-precint"
                name="obreby"
                className="form-control needsclick"
                value={this.state.selectedPrecint}
                onChange={(e) => this.onChangePrecint(e)}
              >
                {obreby.map((v, i) => {
                  return <option key={i} value={v.obreb}>{v.nazwa_obrebu}</option>
                })}
              </select>
            </div>
            <div className={rightCol} />
          </div>
        }
        {this.props.dokumentType.enableParcels && this.state.selectDzialki && this.state.selectedSposob !== 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="select-parcels" style={labelStyle} >Działki</label>
            </div>
            <div className={inputCol}>
              <Select
                id="select-parcels"
                noResultsText={'brak wyników'}
                placeholder={<span style={{ color: '#555' }}>Wpisz numer działki...</span>}
                multi
                name="form-field-name"
                value={this.state.selectedParcels}
                options={this.state.parcels}
                clearable={false}
                onBlur={event => event.preventDefault()}
                onInputChange={(e) => this.matcher(e)}
                onChange={this.logChange}
                optionClassName="needsclick"
                blurInputOnSelect={false}
                style={{color: 'black'}}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {this.props.dokumentType.enableRoads && this.state.selectDrogi && this.state.selectedSposob === 2 &&
          <div className="row">
            <div className={leftCol} />
            <div className={labelCol}>
              <label htmlFor="select-roads" style={labelStyle} >Drogi</label>
            </div>
            <div className={inputCol}>
              <Select
                id="select-roads"
                noResultsText={'brak wyników'}
                placeholder={<span style={{ color: '#555' }}>Wpisz numer drogi...</span>}
                multi
                name="form-field-name"
                value={this.state.selectedRoads}
                options={this.state.roads}
                clearable={false}
                onChange={this.roadChange}
                onBlur={event => event.preventDefault()}
                optionClassName="needsclick"
                blurInputOnSelect={false}
              />

            </div>
            <div className={rightCol}>
              <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
            </div>
          </div>
        }
        {
          this.state.isMounted ? this.mapRender() : <div style={waitingContainer}>
            <img alt="Loader" src={waiting} />
          </div>
        }
        {this.props.showPdfExport && (
          <Row
            key='pdfExportRow'
            style={{ margin: 0, display: 'flex', alignItems: 'center' }}
          >
            <Col
              xs={12}
              sm={3}
              className="text-center text-sm-start"
              style={{ padding: 0 }}
            >
              <label style={{ margin: 0 }}>Generowanie załącznika z mapy:</label>
            </Col>
            <Col
              xs={12}
              sm={9}
              className="text-center text-sm-end"
              style={{ padding: 0 }}
            >
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.setState({ loading: true }, () => this.exportMapToPdf())}
                style={{ float: 'right' }}
              >
                Wygeneruj załącznik
              </button>
            </Col>
          </Row>
        )}
        {this.state.parcelError ?
          <div><h5><b>{this.state.parcelError}</b></h5></div>
          : null
        }
      </div>
    );
  }
}

CustomizedMap.propTypes = {
  obreby: PropTypes.array,
  district: PropTypes.object,
  settings: PropTypes.object,
  setParcels: PropTypes.func,
  setRoads: PropTypes.func,
  setSelectDrogi: PropTypes.func,
  setSelectDzialki: PropTypes.func,
};

const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default connect(mapState)(CustomizedMap);



// WEBPACK FOOTER //
// src/routes/eservices/CustomizedMap.js